export default function initMarginTop(): void {
  const updateScrollMargin = () => {
    const header = document.getElementById('site-header')
    if (header) {
      const headerHeight = header.offsetHeight
      document.documentElement.style.setProperty('--scroll-margin', `${headerHeight}px`)
    }
  }

  updateScrollMargin()

  let resizeTimer: ReturnType<typeof setTimeout>
  window.addEventListener(
    'resize',
    () => {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(updateScrollMargin, 100)
    },
    { passive: true }
  )
}
